export enum ContactState {
    Completed = 'Complete',
    Active = 'Active',
    InQueue = 'inQueue'
}